export const isModelLandingPage = (url = '') => {
  // eslint-disable-next-line security/detect-unsafe-regex
  return url.match(/models\/(?:[^/]+\/)?([^/]+)\//);
};
